export default __webpack_public_path__ + "static/media/HomepplLogo-full.7c8515b6.svg";